/**
 * Безопасные ссылки для href: внешние данные (RSS, письма, импорт) могут подсунуть `javascript:` или `data:`,
 * а React 18 такие ссылки не блокирует — клик выполнил бы скрипт на нашем домене.
 */

/** Только http(s); всё прочее — пустая строка. */
export function httpUrl(u: string | null | undefined): string {
  const s = (u ?? '').trim();
  return /^https?:\/\//i.test(s) ? s : '';
}

/** Ссылка, введённая человеком: без схемы — https://, чужая схема тоже обезвреживается префиксом. */
export function safeUrl(u: string | null | undefined): string {
  const s = (u ?? '').trim();
  if (!s) return '';
  return /^https?:\/\//i.test(s) ? s : `https://${s}`;
}
